import { BankRegNr } from '@/domain/session';
import { BANKS_LEAVING } from '@/utils/bank-utils';

import { useSession } from '@components/app/Session';

interface BankAllowedOperations {
    canOrderCard: boolean;
    canReorderCard: boolean;
    canFetchDebitInformation: boolean;
}

const useBankIsLeaving = () => {
    const session = useSession();

    return BANKS_LEAVING.includes(session?.bank?.registrationNumber as BankRegNr);
};

const useBankAllowedOperations = (): BankAllowedOperations => {
    const bankIsLeaving = useBankIsLeaving();

    if (bankIsLeaving) {
        return {
            canOrderCard: false,
            canReorderCard: false,
            canFetchDebitInformation: false,
        };
    }

    return {
        canOrderCard: true,
        canReorderCard: true,
        canFetchDebitInformation: true,
    };
};

export default useBankAllowedOperations;
